import { render } from "./UseStockOut.vue?vue&type=template&id=e72e4240&scoped=true&ts=true"
import script from "./UseStockOut.vue?vue&type=script&lang=ts"
export * from "./UseStockOut.vue?vue&type=script&lang=ts"

import "./UseStockOut.vue?vue&type=style&index=0&id=e72e4240&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72e4240"]])

export default __exports__